import type { InterventionsBatchEditScheduledDateProps } from "./interventions-batch-edit-scheduled-date.type";

import { DatePicker, Form } from "antd";
import { useTranslation } from "react-i18next";

import BatchEditForm from "@/modules/batch-edit-form";

import { useInterventionsBatchEditScheduledDate } from "./interventions-batch-edit-scheduled-date.hook";

const InterventionsBatchEditScheduledDate = ({
  interventions,
}: InterventionsBatchEditScheduledDateProps) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useInterventionsBatchEditScheduledDate(interventions);

  return (
    <BatchEditForm
      modelKey="intervention"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
    >
      <Form.Item
        name={fieldName}
        label={t("intervention:batchEdit.scheduledDate.label")}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      >
        <DatePicker />
      </Form.Item>
    </BatchEditForm>
  );
};

export default InterventionsBatchEditScheduledDate;
